import { render, staticRenderFns } from "./MyChat.vue?vue&type=template&id=69ede2e7&"
import script from "./MyChat.vue?vue&type=script&lang=js&"
export * from "./MyChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69ede2e7')) {
      api.createRecord('69ede2e7', component.options)
    } else {
      api.reload('69ede2e7', component.options)
    }
    module.hot.accept("./MyChat.vue?vue&type=template&id=69ede2e7&", function () {
      api.rerender('69ede2e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Camstudy/control/MyChat.vue"
export default component.exports